import React from 'react';
import { Card, Typography } from 'antd';
import type { OwnerDashboardStats } from '../../../services/statsApi';
import styles from './KpiStrip.module.css';

const { Text } = Typography;

interface KpiStripProps {
  stats: OwnerDashboardStats | null;
}

const fmtMoney = (n?: number, fractionDigits = 2) =>
  `$${(n ?? 0).toLocaleString('en-US', {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })}`;

const KpiCard: React.FC<{
  title: string;
  value: React.ReactNode;
  sub?: React.ReactNode;
  valueColor?: string;
}> = ({ title, value, sub, valueColor }) => (
  <Card size="small" styles={{ body: { padding: 16 } }}>
    <Text type="secondary" style={{ fontSize: 12 }}>{title}</Text>
    <div style={{ fontSize: 22, fontWeight: 700, color: valueColor }}>{value}</div>
    {sub && <Text type="secondary" style={{ fontSize: 12 }}>{sub}</Text>}
  </Card>
);

const KpiStrip: React.FC<KpiStripProps> = ({ stats }) => {
  const revenueMTD = stats?.revenueMTD ?? 0;
  const growth = stats?.revenueGrowth ?? 0;
  const aro = stats?.averageTicketValue ?? 0;
  const cars = stats?.carCountMTD ?? 0;
  const closeRate = stats?.estimateCloseRate;
  const growthColor = growth >= 0 ? '#52c41a' : '#ff4d4f';

  return (
    <div className={styles.strip} role="region" aria-label="Owner KPI strip">
      <KpiCard title="Revenue MTD" value={fmtMoney(revenueMTD)} sub="this month" />
      <KpiCard
        title="Revenue Growth"
        value={<span style={{ color: growthColor }}>{growth >= 0 ? '+' : ''}{growth.toFixed(1)}%</span>}
        sub="vs. last month"
        valueColor={growthColor}
      />
      <KpiCard title="ARO" value={fmtMoney(aro, 0)} sub="avg repair order" />
      <KpiCard title="Cars Completed (MTD)" value={String(cars)} sub="this month" />
      <KpiCard
        title="Estimate Close Rate"
        value={closeRate === null || closeRate === undefined ? '—' : `${closeRate.toFixed(1)}%`}
        sub="approved or converted"
      />
    </div>
  );
};

export default KpiStrip;
